import loadable from "@loadable/component";
import React, { useContext, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router";
import Layout from "@components/common/layout/Layout";
import { CHOOSE_DOMAIN_ROUTE, LOGIN_ROUTE } from "@constants/routes";
import SecurityContext from "@contexts/security/SecurityContext";

export default function RoutesWrapper() {
  const { isAuthenticated } = useContext(SecurityContext);
  const navigate = useNavigate();

  const LoginPage = loadable(() => import("@pages/security/LoginPage"));
  const ChooseDomainPage = loadable(
    () => import("@pages/chooseDomain/ChooseDomainPage"),
  );
  const Error404Page = loadable(() => import("@pages/error/Error404Page"));

  useEffect(() => {
    if (isAuthenticated) {
      return;
    }

    navigate(LOGIN_ROUTE);
  }, [isAuthenticated]);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<LoginPage />} />
        <Route path={CHOOSE_DOMAIN_ROUTE} element={<ChooseDomainPage />} />
        <Route path="*" element={<Error404Page />} />
      </Route>
    </Routes>
  );
}
